import { useTranslation } from 'react-i18next';
import { StringListEditor } from './StringListEditor';
import { parseGridOptions, serializeGridOptions } from '../../adapters/field-type.adapter';

interface GridEditorProps {
  fieldId: string;
  optionsJson: string | null | undefined;
  onChange: (optionsJson: string) => void;
  disabled?: boolean;
}

export function GridEditor({ fieldId, optionsJson, onChange, disabled = false }: GridEditorProps) {
  const { t } = useTranslation('forms');
  const value = parseGridOptions(optionsJson ?? null);

  return (
    <div className="space-y-3">
      <StringListEditor
        idPrefix={fieldId}
        label={t('builder.grid.rowsLabel')}
        values={value.rows}
        onChange={(rows) => onChange(serializeGridOptions({ ...value, rows }))}
        addLabel={t('builder.grid.addRow')}
        deleteLabel={t('builder.grid.deleteRow')}
        testIdPrefix="forms-builder-grid-row"
        disabled={disabled}
      />
      <StringListEditor
        idPrefix={fieldId}
        label={t('builder.grid.columnsLabel')}
        values={value.columns}
        onChange={(columns) => onChange(serializeGridOptions({ ...value, columns }))}
        addLabel={t('builder.grid.addColumn')}
        deleteLabel={t('builder.grid.deleteColumn')}
        testIdPrefix="forms-builder-grid-column"
        disabled={disabled}
      />
    </div>
  );
}
